import { AuthCard, AuthLayout } from "./Shared"
import { FlexRowCenter, HR, Spacer } from "../atoms/Atoms"
import { CenteredLoadingIndicator } from "../molecules/Molecules"
import React from "react"
import DefaultMarkdown from "../DefaultMarkdown"
import L10n from "../../../lib/carrot-l10n"
import { Body } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const EmailSentMessage = ({ message, header }) => (
  <div className="tc">
    <div className="flex justify-center mt35">
      <H1>{header}</H1>
    </div>
    <Spacer height={1.5} />
    <Body color="black-80">
      <DefaultMarkdown source={message} />
    </Body>
  </div>
)

const RequestPasswordFooter = () => (
  <>
    <Spacer height={1.5} />
    <HR color="light-gray" />
    <Spacer height={0.75} />
    <FlexRowCenter>
      <ArrowLink arrowRotation="rotate-180" to="/">
        {l`client.backToSignIn`}
      </ArrowLink>
    </FlexRowCenter>
  </>
)

const RequestResetPassword = ({ message, header }) => (
  <AuthLayout title={l`client.resetPassword`}>
    <AuthCard>
      <Spacer height={2.5} />
      <FlexRowCenter>
        {message ? <EmailSentMessage message={message} header={header} /> : <CenteredLoadingIndicator />}
      </FlexRowCenter>
      <RequestPasswordFooter />
    </AuthCard>
  </AuthLayout>
)

export default RequestResetPassword
